import React from "react";
import styled from "styled-components";
import { Button } from "./Button";

const Element = styled.div``;

type Props = {
  fallbackMessage?: string;
};
type State = {
  error: Error | null;
};
class ErrorBoundary extends React.Component<
  React.PropsWithChildren<Props>,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      error: null
    };
  }
  public componentDidCatch(error: Error) {
    this.setState({ error });
  }
  public render() {
    const {
      children,
      fallbackMessage = "There has been an error!"
    } = this.props;
    const { error } = this.state;
    if (error) {
      return (
        <Element>
          <pre>{error.message || fallbackMessage}</pre>
          <Button appearance="primary" onClick={() => window.location.reload()}>
            Reload
          </Button>
        </Element>
      );
    }
    return children;
  }
}

export default ErrorBoundary;
